import { Text, Tooltip } from "@shopify/polaris"
import { observer } from "mobx-react"
import React from "react"

import { StatusIcon } from "@/assets/svg/StatusIcon"
import Store from "@/stores"
import { formatDisplayNumber, formatPlanPrice } from "@/utils/formatNumber"

export const PaymentChildrenPrice = (props: {
  current: any
  user_pkg: any
  type: number
  package_kind: number
}) => {
  const { current, user_pkg, type, package_kind } = props

  if (package_kind === 1) {
    return (
      <Text variant="headingXl" as="span" fontWeight="bold">
        ${0}
      </Text>
    )
  }

  const displayPrice = current?.actual_price
  const showStrikethrough =
    Number(current?.origin_price) !== Number(current?.actual_price) &&
    current?.id !== user_pkg?.package_id &&
    type !== 2

  return (
    <div className="flex items-end gap-2">
      <div className="flex items-baseline whitespace-nowrap">
        <Text variant="headingXl" as="span" fontWeight="bold">
          ${formatPlanPrice(displayPrice)}
        </Text>
        <Text variant="bodyMd" as="span">
          /{t("Month")}
        </Text>
      </div>
      {showStrikethrough && (
        <Text variant="bodyMd" as="span" tone="subdued">
          <span className="text-[#b5b5b5] line-through">
            ${formatPlanPrice(current?.origin_price)}
          </span>
        </Text>
      )}
    </div>
  )
}

export const PaymentChildrenFeatureItem = (props: {
  text: string
  tooltipContent?: string
  withoutFeature?: boolean
}) => {
  const icon = <StatusIcon x={props.withoutFeature} />
  const textNode = props.tooltipContent ? (
    <div
      className="cursor-pointer whitespace-nowrap"
      style={{ borderBottom: "1px dashed #E1E3E5" }}
    >
      {props.text}
    </div>
  ) : (
    <Text variant="bodyMd" as="span">
      {props.text}
    </Text>
  )

  const content = (
    <div className="flex items-center gap-2">
      {icon}
      {textNode}
    </div>
  )

  return props.tooltipContent ? (
    <Tooltip content={props.tooltipContent} preferredPosition="above">
      {content}
    </Tooltip>
  ) : (
    content
  )
}

export const PaymentChildrenQuote = (props: {
  quota: any
  type: number
  package_kind: number
}) => {
  const { quota, type, package_kind } = props

  if (package_kind === 1) {
    return (
      <Text variant="bodyMd" as="span" fontWeight="semibold">
        {type === 1
          ? t("ReturnsQuotaMonth", {
              replace: {
                quota: 6,
              },
            })
          : t("ReturnsQuotaYear", {
              replace: {
                quota: 72,
              },
            })}
      </Text>
    )
  }

  return (
    <Text variant="bodyMd" as="span" fontWeight="semibold">
      {type === 1
        ? t("ReturnsQuotaMonth", {
            replace: {
              quota: formatDisplayNumber(quota),
            },
          })
        : t("ReturnsQuotaYear", {
            replace: {
              quota: formatDisplayNumber(quota),
            },
          })}
    </Text>
  )
}

const PaymentChildrenExtra = (props: {
  price: any
  type: number
  package_kind: number
}) => {
  const { price, type, package_kind } = props
  const { showReturnServiceShow } = Store.PlanStore

  if (package_kind === 1) {
    return <div aria-hidden className="h-8 shrink-0" />
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-lg bg-[#f3f3f3] px-3 py-[6px]">
      <Text variant="bodyMd" as="p">
        {type === 1
          ? `$${t("OnePricePerExtraReturn", {
              replace: {
                price: formatPlanPrice(price),
              },
            })}`
          : t("UnavailableAfterExceeded")}
      </Text>
      {type === 1 && package_kind >= 2 && showReturnServiceShow === 1 ? (
        <Text variant="bodyMd" as="p">
          {t("1_9ReturnProtectionSales")}
        </Text>
      ) : null}
    </div>
  )
}

export default observer(PaymentChildrenExtra)
